import { animate, AnimationTriggerMetadata, style, transition, trigger } from '@angular/animations';

export const slideInFromLeft: AnimationTriggerMetadata = trigger('slideInFromLeft', [
  transition(':enter', [style({ transform: 'translateX(-100%)', opacity: 0 }), animate('0.3s ease-in-out', style({ transform: 'translateX(0)', opacity: 1 }))]),
  transition(':leave', [animate('0.3s ease-in-out', style({ transform: 'translateX(-100%)', opacity: 0 }))])
]);
